export default {
  'financial.billsToPay.form.situation': 'Situation',
  'financial.billsToPay.form.situation.open': 'Open',
  'financial.billsToPay.form.situation.liquidated': 'Liquidated',
  'financial.billsToPay.form.filterByDate': 'Filter By Date',
  'financial.billsToPay.form.filterByDate.maturity': 'Maturity',
  'financial.billsToPay.form.filterByDate.payment': 'Payment',
  'financial.billsToPay.form.filterByDate.issuance': 'Issuance',
  'financial.billsToPay.form.display': 'Display',
  'financial.billsToPay.form.display.payReceive': 'Accounts Payable/Receivable',
  'financial.billsToPay.form.display.tariffs': 'Tariffs',
  'financial.billsToPay.form.display.showRefund': 'Show Refund',
  'financial.billsToPay.form.display.singleEntries': 'Single Entries',
  'financial.billsToPay.form.moreOptions': 'More Options',
  'financial.billsToPay.form.filterExpensesBy': 'Filter Expenses By',
  'financial.billsToPay.form.filterExpensesBy.none': 'None',
  'financial.billsToPay.form.filterExpensesBy.fixedExpenses': 'Fixed Expenses',
  'financial.billsToPay.form.filterExpensesBy.variable Expenses':
    'variableExpenses',
  'financial.billsToPay.form.filterExpensesBy.Without Classification':
    'withoutClassification',
  'financial.billsToPay.form.chartOfAccounts': 'Chart Of Accounts',
};
